<script lang="ts">
  import { onMount } from "svelte"
  import * as Carousel from "$lib/components/ui/carousel"
  import { createEventDispatcher } from "svelte"

  let { competition, layout } = $props()

  let carouselVisible = $state(true)
  let currentIndex = $state(0)
  let emblaApi: any = null
  const dispatch = createEventDispatcher()

  // Function to navigate to a specific slide
  function goToSlide(index: number) {
    console.log("Attempting to go to slide:", index, "API:", emblaApi)

    if (emblaApi) {
      emblaApi.scrollTo(index)
      currentIndex = index
    } else {
      console.error("Carousel API not available")
      // Try to dispatch an event to the carousel
      dispatch("scrollTo", { index })
    }
  }

  // Function to handle API initialization
  function onInit(api: any) {
    console.log("Embla initialized with API:", api)
    emblaApi = api

    // Set up listener for slide changes
    emblaApi.on("select", () => {
      currentIndex = emblaApi.selectedScrollSnap()
    })
  }

  onMount(async () => {
    // Check if any competition images exist and are valid
    if (competition.images && competition.images.length > 0) {
      const checkImage = (url) => {
        return new Promise((resolve) => {
          const img = new Image()
          img.onload = () => resolve(true)
          img.onerror = () => resolve(false)
          img.src = url.replace(
            "https://img.promoamp.com/",
            "https://img.promoamp.com/cdn-cgi/image/width=1000/",
          )
        })
      }

      // Check all images
      const results = await Promise.all(competition.images.map(checkImage))
      if (results.every((result) => !result)) {
        carouselVisible = false
      }
    }
  })
</script>

{#if carouselVisible}
  {#if competition.is_demo_for}
    <div class="relative w-full h-[300px] overflow-hidden sm:rounded-t-[10px]">
      {#if competition.images && competition.images.length > 0}
        <div
          class="absolute inset-0"
          style="background-image: url('{competition
            .images[0]}'); background-size: cover; background-position: center; background-repeat: no-repeat;"
        ></div>
      {/if}
      <div
        class="absolute inset-0"
        style={competition.widgetCustomizations.primaryBackgroundColor
          ? `background-color: ${competition.widgetCustomizations.primaryBackgroundColor}; opacity: 0.6;`
          : "background-color: #000000; opacity: 0.6;"}
      ></div>
      <div
        class="absolute inset-0 flex flex-col items-center justify-center gap-2"
      >
        <span class="giveaway-text outlined">GIVEAWAY</span>
        <span class="giveaway-text solid">GIVEAWAY</span>
        <span class="giveaway-text outlined">GIVEAWAY</span>
        <span class="giveaway-text solid">GIVEAWAY</span>
        <span class="giveaway-text outlined">GIVEAWAY</span>
      </div>
    </div>
  {:else if competition.images && competition.images.length > 0}
    <Carousel.Root
      options={{ loop: true }}
      on:init={({ detail }) => onInit(detail)}
    >
      <Carousel.Content>
        {#each competition.images as image}
          <Carousel.Item>
            <img
              src={image.replace(
                "https://img.promoamp.com/",
                "https://img.promoamp.com/cdn-cgi/image/width=1000/",
              )}
              alt="Competition promotional content"
              class="w-full object-cover"
              class:sm:rounded-t-[6px]={layout !== "landscape"}
              class:max-h-[300px]={layout !== "landscape"}
              class:sm:rounded-tl-[6px]={layout === "landscape"}
              class:sm:rounded-tr-[0px]={layout === "landscape"}
            />
          </Carousel.Item>
        {/each}
      </Carousel.Content>
      {#if competition.images.length > 1}
        <div
          class="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 px-3 py-1.5 rounded-full bg-black/20 backdrop-blur-sm"
        >
          {#each competition.images as _, i}
            <Carousel.Dot index={i} />
          {/each}
        </div>
      {/if}
    </Carousel.Root>
  {/if}
{/if}

<style>
  .giveaway-text {
    font-size: 2.8rem;
    font-weight: 900;
    letter-spacing: 0.1em;
    line-height: 1;
  }

  .giveaway-text.outlined {
    color: transparent;
    -webkit-text-stroke: 2px white;
  }

  .giveaway-text.solid {
    color: white;
  }
</style>
